import { LocalizedTicketTypes } from 'apollo/localizedTypes';

const ticketTypesMapper = (ticketTypes: LocalizedTicketTypes) => {
  const entranceTypes = {
    label: 'Entradas',
    options:
      ticketTypes?.listEntranceTicketTypesBackOffice.map((type) => {
        return { label: type.name.es, value: type.name.es };
      }) || [],
  };
  const activityTypes = {
    label: 'Actividades',
    options:
      ticketTypes?.listActivitiesBackOffice.map((type) => {
        return { label: type.name, value: type.name };
      }) || [],
  };
  return [entranceTypes, activityTypes];
};

export default ticketTypesMapper;
